import adminDefaultAPI from '../../api';
import handleQueryError from '../../../../util/Common/Error/Handler/handleQueryError';

const getUser = async ({ id }) => {
  try {
    const response = await adminDefaultAPI.get(`user/${id}`);
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default getUser;
